import Components from "../components";

class MarkdownEditor extends Components.Base {
  initialize() {
    this.$textarea = this.$el.find("textarea");
    this.$preview = this.$el.find(".preview");
  }

  bind() {
    this.on("focus", "textarea", () => this.updateHeight());
    this.on("keydown", "textarea", (e) => this.onKeyDown(e));
    this.on("paste", "textarea", (e) => this.onPaste(e));
    this.on("shown.bs.tab", ".preview-tab", () => this.updatePreview());
    this.on("shown.bs.tab", ".write-tab", () => this.$textarea.focus());
    this.on("keyup", "textarea", () => this.updateHeight());
    this.on("click", ".cancel", () => this.reset());
  }

  onPaste(event) {
    const clipboardData =
      event.originalEvent && event.originalEvent.clipboardData;
    if (!clipboardData || typeof clipboardData.getData !== "function") return;

    const pastedText =
      clipboardData.getData("text/plain") ||
      clipboardData.getData("text") ||
      "";
    if (!pastedText) return;
    if (!/^https?:\/\/\S+$/.test(pastedText)) return;

    const textarea = this.$textarea[0];
    const selectionStart = textarea.selectionStart;
    const selectionEnd = textarea.selectionEnd;
    if (selectionStart === selectionEnd) return;

    event.preventDefault();
    const selectedText = textarea.value.slice(selectionStart, selectionEnd);
    const escapedSelectedText = selectedText.replace(/]/g, "\\]");
    const markdownUrl = pastedText.includes(")")
      ? `<${pastedText}>`
      : pastedText;
    const replacement = `[${escapedSelectedText}](${markdownUrl})`;
    textarea.setRangeText(replacement, selectionStart, selectionEnd, "end");
    this.$textarea.trigger("input");
    this.updateHeight();
  }

  onKeyDown(event) {
    if ((event.metaKey || event.ctrlKey) && event.keyCode === 13) {
      event.preventDefault();
      this.$el.find("button[type=submit]").click();
    }
  }

  updatePreview() {
    const commentBody = this.$textarea.val();
    if (/\S/.test(commentBody)) {
      this.$preview.html(
        '<i class="fa fa-cog fa-spin fa-fw"></i><span> Loading...</span>',
      );
      $.ajax("/markdown_renderings", {
        method: "POST",
        data: { markdown: commentBody },
        dataType: "html",
        success: (data) => {
          this.$preview.html(data);
        },
        error: () => {
          this.$preview.html("Error Previewing");
        },
      });
    } else {
      this.$preview.html("Nothing to Preview");
    }
  }

  updateHeight() {
    this.$textarea.height("auto");
    const cs = getComputedStyle(this.$textarea[0]);
    const newHeight =
      this.$textarea.prop("scrollHeight") -
      parseFloat(cs.paddingTop) -
      parseFloat(cs.paddingBottom) +
      20;
    const newHeightPx = `${newHeight}px`;
    this.$textarea.height(newHeightPx);
    this.$preview.css("min-height", newHeightPx);
  }

  reset() {
    this.$el.find("form")[0].reset();
  }
}

Components.collection.register({
  selector: ".c-markdown-editor",
  klass: MarkdownEditor,
});
